import styled from 'styled-components/macro'
import { Content, Small, Title } from './elements'

export default styled.div`
  width: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
  border-radius: ${props => props.theme.borderRadius};
  margin-bottom: ${props => !props.collapsed && props.marginBottom};
  border: ${props => props.collapsed ? 'none' : `1px solid ${props.theme.colors.gray[3]}`};
  padding: 0 ${props => props.theme.padding};
  height: ${props => props.collapsed ? 0 : props.height};
  direction: rtl;
  transition: all .3s ease-in-out;
  * {
    display: ${props => props.collapsed && 'none'};
  }
  &:hover,
  &:active {
    border: 1px solid ${props => props.theme.colors.gray[2]};
    box-shadow: 1px 2px 3px rgba(50, 50, 50, 0.1);
  }

  &.disabled {
    opacity: 0.98;
    
    &:hover,
    &:active {
      border: 1px solid #e0e0e0;
    }
  }

  &.inverted {
    background-color: #444;
    color: #fff;
    * {
      color: #fff;
    }
    &:hover,
    &:active {
      border: 1px solid #e0e0e0;
    }
  }
`

export const GiftItem = styled.div`
  width: calc(100% - 90px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
`

export const GiftIcon = styled.img`
  width: 32px;
  border-radius: 5px;
`

export const GiftContent = styled(Content)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  color: ${props => props.theme.colors.gray[1]};
  padding-bottom: ${props => props.theme.halfSpace};
`

export const GiftTitle = styled(Title)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  margin: ${props => props.theme.halfSpace} 0;
`

export const GiftDescription = styled(Small)`
  color: ${props => props.colors.gray[1]};
`
